export default "__VITE_ASSET__Cq4_yEF1__"